import { render, staticRenderFns } from "./host-set-region.vue?vue&type=template&id=bbd98832&scoped=true&"
import script from "./host-set-region.vue?vue&type=script&lang=js&"
export * from "./host-set-region.vue?vue&type=script&lang=js&"
import style0 from "./host-set-region.vue?vue&type=style&index=0&id=bbd98832&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd98832",
  null
  
)

export default component.exports